import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import { SURVEY_COLORS } from "./shared/theme-constants";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
export const useDialogStyles = makeStyles((theme: Theme) => ({
  "@global": {
    "#new_learning_survey_dialog .MuiDialog-paper": {
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      "@media (min-width: 600px)": {
        height: "calc(90vh - 48px)",
        maxHeight: "calc(90vh - 48px)",
        position: "relative",
      },
    },
    "@media (min-width: 600px)": {
      "#new_learning_survey_dialog .MuiDialog-paper:has(#loading-state)": {
        height: "50vh",
        maxHeight: "50vh",
      },
      "#new_learning_survey_dialog .MuiDialog-paper:has(#loading-state) > div": {
        height: "100%",
        maxHeight: "100%",
      },
    },
  },
  // Header styling with gradient
  gradientHeader: {
    position: "relative",
    flexShrink: 0,
    background: `linear-gradient(to right, ${SURVEY_COLORS.GRADIENT_PURPLE}, ${SURVEY_COLORS.GRADIENT_PURPLE_LIGHT}, ${SURVEY_COLORS.GRADIENT_BLUE})`,
    color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    padding: "24px",
    borderBottom: "none",
    overflow: "hidden",
    "&::before": {
      content: '"',
      position: "absolute",
      inset: 0,
      background: SURVEY_COLORS.MODAL_GRADIENT_OVERLAY,
      pointerEvents: "none",
    },
  },
  headerContent: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    zIndex: 1,
  },
  headerTitle: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  iconBox: {
    width: "40px",
    height: "40px",
    backgroundColor: SURVEY_COLORS.MODAL_ICON_BG,
    backdropFilter: "blur(8px)",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  titleText: {
    fontSize: "24px",
    fontWeight: 700,
    color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    margin: 0,
  },
  closeButton: {
    color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    backgroundColor: SURVEY_COLORS.MODAL_CLOSE_BG,
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: SURVEY_COLORS.MODAL_CLOSE_HOVER,
      outline: `2px solid ${SURVEY_COLORS.WHITE}`,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${SURVEY_COLORS.WHITE}`,
      fontWeight: 700,
      "& .MuiTouchRipple-child": {
        backgroundColor: "transparent",
      },
    },
  },
  sparkleFloat1: {
    position: "absolute",
    top: "16px",
    right: "80px",
    color: SURVEY_COLORS.MODAL_SPARKLE_1,
    animation: "$float 3s ease-in-out infinite",
  },
  sparkleFloat2: {
    position: "absolute",
    bottom: "8px",
    right: "128px",
    color: SURVEY_COLORS.MODAL_SPARKLE_2,
    animation: "$float 4s ease-in-out infinite 1s",
  },
  "@keyframes float": {
    "0%, 100%": {
      transform: "translateY(0px)",
    },
    "50%": {
      transform: "translateY(-10px)",
    },
  },
  surveyBody: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 48px)",
    maxHeight: "calc(100vh - 48px)",
    minHeight: 0,
    overflow: "hidden",
    overscrollBehavior: "contain",
    [theme.breakpoints.down("sm")]: {
      height: "100%",
      maxHeight: "100%",
    },
  },
  contentWrapper: {
    flex: 1,
    flexBasis: 0,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    overscrollBehavior: "contain",
    WebkitOverflowScrolling: "touch",
  },
  contentContainer: {
    overflow: "visible",
  },
}));
